import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { accountAPI } from '../data/account';
import pt from '../locales/pt';
import { paths } from '../routes/paths';
import { Button } from '../components/ui/Button';

export function ConfirmEmailChange() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Link inválido.');
      return;
    }

    let cancelled = false;
    (async () => {
      const response = await accountAPI.confirmEmailChange({ token });
      if (cancelled) return;
      if (!response.success) {
        setStatus('error');
        setMessage(response.message);
        return;
      }
      setStatus('success');
      setMessage(response.data?.detail || 'Email actualizado.');
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 py-12 text-center">
      <h1 className="font-display text-2xl font-bold text-foreground">Confirmar email</h1>
      {status === 'loading' ? (
        <p className="mt-4 text-muted-foreground">{pt.common.loading}</p>
      ) : (
        <p className={`mt-4 ${status === 'error' ? 'text-error' : 'text-muted-foreground'}`}>
          {message}
        </p>
      )}
      <div className="mt-8 flex flex-col gap-2 sm:flex-row">
        <Button type="button" onClick={() => navigate(paths.signIn)}>
          {pt.auth.signIn.signIn}
        </Button>
        <Button type="button" variant="outline" asChild>
          <Link to={paths.settingsAccount}>Definições</Link>
        </Button>
      </div>
    </div>
  );
}
